import { render, staticRenderFns } from "./KPromoEditForm.vue?vue&type=template&id=61e6d5f4&"
import script from "./KPromoEditForm.vue?vue&type=script&lang=js&"
export * from "./KPromoEditForm.vue?vue&type=script&lang=js&"
import style0 from "./KPromoEditForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports